import React from 'react';
import { LoadingPlaceholder } from '@thd-olt-component-react/loading-placeholder';
import { bool } from 'prop-types';

export const MediaGalleryLoader = ({ isMobile }) => {
  return (
    <LoadingPlaceholder
      type="mediaGallery"
      ready={false}
      color="#E0E0E0"
      showLoadingAnimation
      rows={0}
      isMobile={isMobile}
    >
      Media Loader
    </LoadingPlaceholder>
  );
};

MediaGalleryLoader.displayName = 'MediaGalleryLoader';

MediaGalleryLoader.propTypes = {
  isMobile: bool.isRequired
};
